import React, { useEffect, useState } from 'react';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';

import { Axios } from 'helpers/axios';
import IconButton from 'components/common/IconButton';

const DemandeDPSLightStep3 = ({
    watch1,
    watch2,
    resetForm,
}) => {
    const [isLoading, setIsLoading] = useState(true);

    const sendToDB = async () => {
        try {
            setIsLoading(true);
            const sendToBO = await Axios.post('/publicRoutes/enregistrerDemandeLightDPS',{
                orgaRaisonSociale            : watch1("orgaRaisonSociale"),
                orgaRepresentePar            : watch1("orgaRepresentePar"),
                orgaRepresenteParFonction    : watch1("orgaRepresenteParFonction"),
                orgaRepresenteParMail        : watch1("orgaRepresenteParMail"),
                orgaRepresenteParTel         : watch1("orgaRepresenteParTel"),

                libelleEvenement             : watch2("libelleEvenement"),
                dateDebutEvenement           : watch2("dateDebutEvenement"),
                manifRemarques               : watch2("manifRemarques"),
            });

            await Axios.post('/publicRoutes/cloreDemandeDPS',{
                idDPSdemande: sendToBO.data.idDPSdemande,
                demandeUpdateCode: sendToBO.data.demandeUpdateCode,
            });

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        sendToDB();
    },[])
    
    if(isLoading)
    {
        return(<LoaderInfiniteLoop />);
    }else{
        return (<>
            <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-success"}>
                <center>
                    <h5 className='text-success mb-2'><b>MERCI</b></h5>
                    <p>Votre demande est bien prise en compte, nous reviendrons vers vous rapidement.</p>
                    <IconButton
                        icon={'recycle'}
                        onClick={resetForm}
                        className='mt-3'
                        size='sm'
                        variant='outline-primary'
                    >Faire une autre demande</IconButton>
                </center>
            </div>
        </>);
    }
    
};


DemandeDPSLightStep3.propTypes = {};

export default DemandeDPSLightStep3;